'use strict';
import angular from 'angular';
var CreditCardController = /** @class */ (function () {
    /*@ngInject*/
    function CreditCardController($log, $scope, CreditCardService, AddressService, $mdToast, $timeout) {
        this.months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        this.years = [];
        this.today = new Date();
        this.credentialType = null;
        this.expirationMonth = null; // ES -2876 Removing current month and year.
        this.expirationYear = null;
        this.states = ["PA", "MA", "NH", "CA", "FL"];
        this.countries = ["USA", "Canada"];
        this.cardType = {};
        this.isCardExpired = false;
        this.errors = {};
        this.showAlert = false;
        this.validatorCardType = ''; //stores the CC Type identified by angular-payments
        var self = this;
        this.$log = $log;
        this.$scope = $scope;
        this.ccs = CreditCardService;
        this.addressService = AddressService;
        this.$mdToast = $mdToast;
        this.$timeout = $timeout;
        this.invalidCartType = false;
        this.cardTypes = this.ccs.getCreditCardTypes();
        this.ccs.userCreditCard = this.creditCard;
        this.$log.debug('updateForm...', this.updateForm + ', createForm....', this.createForm);
        //Allow user to pick expiration year from current year +  next 9 years - should have total of 10 years.
        for (var year = this.today.getFullYear(); year < this.today.getFullYear() + 10; year++) {
            this.years.push(year);
        }
        if (this.creditCard && this.creditCard.expirationDate) {
            $log.debug('credit card ===>', this.creditCard);
            this.ccs.creditCardNewAddress = this.creditCard.billingAddress;
            var dateParts = this.creditCard.expirationDate.split("/");
            if (dateParts[1].length === 4) {
                this.expirationMonth = dateParts[0];
                this.expirationYear = dateParts[1];
            }
            else {
                this.expirationMonth = dateParts[1];
                this.expirationYear = dateParts[0];
            }
            this.cardType = this.searchCardType(this.creditCard.cardType);
        }
        else {
            this.creditCard = {};
        }
        //existing address
        this.addressService.getAddresses()
            .then(function (response) {
            self.addresses = response.data.response.currentPage;
        }, function (response) { });
        //end
        // Listening to the event from submit button in parent (container) template
        $scope.$on('publishCreditCardDetails', function (event, data) {
            $scope.$emit('publishedCreditCard', self.getCreditCardJson());
        });
        // Listening to the close dialog event and resetting the credit card form
        $scope.$on('creditCardFormReset', function (event, data) {
            self.creditCard = {};
            $scope.ccForm.$setUntouched();
        });
        // Listening to the event from submit button in parent (container) template
        $scope.$on('creditCardErrors', function (event, data) {
            if (data.errors[0]) {
                if (data.errors[0].code === 1027) {
                    //Invalid credit card number
                    self.invalidErrorMessage = data.errors[0].message;
                    $scope.ccForm.ccNumber.$valid = false;
                    $scope.ccForm.ccNumber.$invalid = true;
                    $scope.ccForm.ccNumber.$error = { 'invalid': true };
                }
                else {
                    //display this message at the top of the modal.
                    console.log('Error API');
                    self.errors.pageErrors = data.errors;
                    self.errors.pageErrorType = 'api';
                    self.errors.havePageErrors = true;
                    self.showAlert = true;
                }
            }
            else {
                self.showAlert = false;
            }
        });
    }
    CreditCardController.prototype.showSimpleToast = function () {
        this.$mdToast.show(this.$mdToast.simple()
            .textContent('Changes have been saved.')
            .hideDelay(2000)
            .position('top right')
            .parent(document.querySelectorAll('#card-update-toast')));
    };
    CreditCardController.prototype.resetInvalidErrorMessage = function () {
        if (this.$scope.ccForm.ccNumber.$error.invalid) {
            this.$scope.ccForm.ccNumber.$error = {};
        }
    };
    CreditCardController.prototype.getCreditCardJson = function () {
        var val = {
            'expirationDate': this.getExpirationDate(this.expirationMonth, this.expirationYear),
            'cardType': this.ccs.getCardType(this.cardType.typeId),
            'cardNickName': this.creditCard.cardNickName,
            'cardNumber': this.creditCard.cardNumber,
            'firstName': this.creditCard.firstName,
            'lastName': this.creditCard.lastName,
            'isDefaultPayment': this.creditCard.isDefaultPayment,
            //Name on card is also a required field for POST /account/payments API
            'nameOnCard': this.creditCard.nameOnCard
        };
        return val;
    };
    CreditCardController.prototype.getExpirationDate = function (month, year) {
        return month + '/' + year;
    };
    CreditCardController.prototype.useExistingAddress = function (address) {
        this.creditCard.billingAddress = address;
        if (this.$scope.ccForm.firstName || this.$scope.ccForm.lastName) {
            this.$scope.ccForm.firstName.$touched = true;
            this.$scope.ccForm.lastName.$touched = true;
        }
    };
    CreditCardController.prototype.searchCardType = function (typeId) {
        for (var i = 0; i < this.cardTypes.length; i++) {
            if (this.cardTypes[i].typeId === typeId) {
                return this.cardTypes[i];
            }
        }
    };
    CreditCardController.prototype.updateCreditCard = function (fieldName) {
        var self = this;
        this.ccs.updateCreditCard(this.creditCard)
            .then(function (response) {
            self.$log.debug('After updating ' + fieldName + ', response is...', response);
            if (response.data.errors.length) {
                //display this message at the top of the modal.
                self.errors.pageErrors = response.data.errors;
                self.errors.pageErrorType = 'api';
                self.errors.havePageErrors = true;
                self.$scope.$broadcast('creditCardErrors', { errors: response.data.errors });
                return;
            }
            else {
                self.$log.debug('After updating the address...', response);
                //ES-3561 setting timeout to close the update credit card form after
                //the success toast goes away.
                self.$timeout(function () {
                    self.$scope.$emit('publishedCreditCard', self.getCreditCardJson());
                }, 3000);
                self.showSimpleToast();
                return;
            }
            // If success then also notify the parent component (credit card list) to update the credit card in the list
            // with this new information
            self.$scope.$emit('updatedCreditCard', self.creditCard);
        });
    };
    CreditCardController.prototype.updateFormCreditCard = function (form) {
        var self = this;
        this.$log.debug('attempt to update nickname..', form.nickName);
        if (form.nickName.$valid && form.expirationMonth.$valid &&
            form.expirationYear.$valid && form.nameOnCard.$valid) {
            this.$log.debug('Update Card Nickname to..' + this.creditCard.cardNickName);
            this.creditCard.expirationDate = this.getExpirationDate(this.expirationMonth, this.expirationYear);
            this.$log.debug("Update userCreditCard ", this.ccs.userCreditCard);
            this.$log.debug("Update creditCardNewAddress ", this.ccs.creditCardNewAddress);
            this.ccs.userCreditCard = self.creditCard;
            //Update the credit card billing address with new information
            self.ccs.creditCardNewAddress = this.creditCard.billingAddress;
            this.updateCreditCard('creditCard');
            this.addressService.updateCreditCardAddress(this.ccs.userCreditCard, this.ccs.creditCardNewAddress).then(function (response) {
                self.$scope.$emit('updatedAddress', self.ccs.creditCardNewAddress);
            });
        }
    };
    CreditCardController.prototype.updateFormDefaultCreditCard = function (form) {
        var self = this;
        this.$log.debug('attempt to update nickname..', form.nickName);
        if (form.nickName.$valid && form.expirationMonth.$valid &&
            form.expirationYear.$valid && form.nameOnCard.$valid) {
            this.$log.debug('Update Card Nickname to..' + this.creditCard.cardNickName);
            this.creditCard.expirationDate = this.getExpirationDate(this.expirationMonth, this.expirationYear);
            this.ccs.userCreditCard = self.creditCard;
            //Update the credit card billing address with new information
            self.ccs.creditCardNewAddress = this.creditCard.billingAddress;
            this.updateCreditCard('defaultCreditCard');
            this.addressService.updateCreditCardAddress(this.ccs.userCreditCard, this.ccs.creditCardNewAddress).then(function (response) {
                self.$scope.$emit('updatedAddress', self.ccs.creditCardNewAddress);
            });
            self.$timeout(function () {
                self.$scope.$emit('publishedCreditCard', self.getCreditCardJson());
            }, 3000);
        }
    };
    CreditCardController.prototype.updateNickName = function (form) {
        this.$log.debug('attempt to update nickname..', form.nickName);
        if (form.nickName.$valid) {
            this.$log.debug('Update Card Nickname to..' + this.creditCard.cardNickName);
            this.updateCreditCard('NickName');
        }
    };
    // checking if card date is expired
    CreditCardController.prototype.isExpired = function (month, year) {
        var today = new Date();
        var cardDate = new Date(year, month);
        if (cardDate < today) {
            this.isCardExpired = true;
        }
        else {
            this.isCardExpired = false;
        }
        return cardDate < today;
    };
    CreditCardController.prototype.updateExpirationDate = function (month, year) {
        var self = this;
        //check if both month and year are provided.
        if (month !== undefined && year !== undefined && month !== null && year !== null) {
            if (!self.isExpired(month, year)) {
                if (this.creditCard !== undefined && this.creditCard !== null) {
                    this.creditCard.expirationDate = this.getExpirationDate(month, year);
                    this.$log.debug('Update expirationMonth/expirationYear to..' + this.creditCard.expirationDate);
                }
            }
        }
    };
    CreditCardController.prototype.updateExpirationMonth = function (form) {
        if (form.expirationMonth.$valid) {
            this.updateExpirationDate(this.expirationMonth, this.expirationYear);
        }
    };
    CreditCardController.prototype.updateExpirationYear = function (form) {
        if (form.expirationYear.$valid) {
            this.updateExpirationDate(this.expirationMonth, this.expirationYear);
        }
    };
    CreditCardController.prototype.updateName = function (form) {
        if (form.nameOnCard.$valid) {
            this.$log.debug('Update name on card to..' + this.creditCard.nameOnCard);
            this.updateCreditCard('nameOnCard');
        }
    };
    // This is to ensure that any changes to our local credit card object don't reflect in
    // the parent object that was passed to us.
    CreditCardController.prototype.$onChanges = function (changes) {
        if (changes.creditCard) {
            this.creditCard = angular.copy(this.creditCard);
        }
        if (changes.updateForm) {
            this.updateForm = angular.copy(this.updateForm);
        }
        if (changes.createForm) {
            this.createForm = angular.copy(this.createForm);
        }
        if (changes.addresses) {
            this.addresses = angular.copy(this.addresses);
        }
    };
    CreditCardController.prototype.validateCard = function (refresh) {
        //Checking whether the method was called when CC type was changed because
        //need to trigger validation if user first enters CC number and then select CC type
        if (this.cardType.typeName) {
            this.invalidCartType = false;
        }
        if (refresh) {
            var tempCCnum = this.$scope.ccForm.ccNumber.cardNumber;
            this.$scope.ccForm.ccNumber.cardNumber = '';
            this.$scope.ccForm.ccNumber.cardNumber = tempCCnum;
            this.resetInvalidErrorMessage();
        }
        var validatorCardType = this.validatorCardType;
        if (this.cardType.typeName != validatorCardType || this.$scope.ccForm.ccNumber.$error.card) { //this.$scope.ccForm.ccNumber.$error.card is set by angular-payments
            if (this.cardType.typeName) {
                this.invalidErrorMessage = "The number you entered is not valid for the card type.";
            }
            else {
                this.invalidCartType = true;
            }
            this.$scope.ccForm.ccNumber.$valid = false;
            this.$scope.ccForm.ccNumber.$invalid = true;
            this.$scope.ccForm.ccNumber.$error = { 'invalid': true };
            this.onCardValidation({ ccNumberInvalid: true });
        }
        else {
            this.onCardValidation({ ccNumberInvalid: false });
        }
    };
    return CreditCardController;
}());
export default CreditCardController;
//# sourceMappingURL=credit-card.controller.js.map